import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { of, Subject } from 'rxjs';
import { catchError, take, takeUntil, timeout } from 'rxjs/operators';
import { DataSourcesEnum } from 'src/app/enums/DataSourcesEnum';
import { ElectionStatusEnum } from 'src/app/enums/ElectionStatusEnum';
import { PageTypeEnum } from 'src/app/enums/PageTypeEnum';
import { IReportTurnout } from 'src/app/interfaces/IReportTurnout';
import { ISelectPage } from 'src/app/interfaces/ISelectPage';
import { ElectionService } from 'src/app/services/election.service';


@Component({
  selector: 'lc-turnout-by-district',
  templateUrl: './lc-turnout-by-district.component.html',
  styleUrls: ['./lc-turnout-by-district.component.scss']
})
export class LcTurnoutByDistrictComponent implements AfterViewInit, OnDestroy {
  @Input() district = 'State';

  private componentDestroyed$: Subject<boolean> = new Subject<boolean>();

  public turnout: IReportTurnout | null = null;
  public title = 'Essential Data';
  public docket = 'HA';
  public isFinal = false;

  constructor(private electionService: ElectionService) {
    this.electionService.dataLoaded$.pipe(takeUntil(this.componentDestroyed$)).subscribe(dataLoaded => {
      if (this.isDataLoaded(dataLoaded.electionDate)) {
        this.loadChart(this.electionService.selectedPage);
      }
    });
    this.electionService.pageChanged$.pipe(takeUntil(this.componentDestroyed$)).subscribe(page => {
      this.loadChart(page);
    });
  }

  private isDataLoaded(electionDateString: string): boolean {
    const election = this.electionService.electionMap.get(electionDateString);
    if (election) {
      return election.dataSourceTrigger([
        DataSourcesEnum.HAChange,
        DataSourcesEnum.HAStatic
      ]);
    }
    return false;
  }

  ngAfterViewInit(): void {
    if (this.isDataLoaded(this.electionService.selectedPage.electionDateString ?? '')) {
      this.loadChart(this.electionService.selectedPage);
    }
  }

  private loadChart(page: ISelectPage): void {
    const election = this.electionService.electionMap.get(page.electionDateString ?? '');
    this.isFinal = election?.lcChange?.electionStatus === ElectionStatusEnum.final;
    if (page.pageType === PageTypeEnum.CountLCStateWide) {
      this.turnout = {
        electorsEnrolled: election?.lcElectionCount?.totalEnrolled ?? 0,
        votesCast: election?.lcElectionCount?.votesCast ?? 0,
        votesCounted: election?.lcElectionCount?.votesCast ?? 0,
        formalVotes: election?.lcElectionCount?.formalVotes ?? 0,
        informalVotes: election?.lcElectionCount?.informalVotes ?? 0,
        formalPercent: election?.lcElectionCount?.formalVotesPercent ?? 0,
        informalPercent: election?.lcElectionCount?.informalVotesPercent ?? 0,
        turnoutPercent: election?.lcElectionCount?.countedPercent ?? 0,
        isProvisional: true,
        reportingRegion: '',
        informality: 0
      };
    }
  }


  // private getTurnout(election: Election){
    // if(election.inProgress == true){
    //   this.currentData.getTurnout(this.configs.currentData, election.electionType, this.district, this.docket)
    //   .pipe(timeout(60000), catchError(error => of('Request timed out')))
    //   .pipe(take(1))
    //   .subscribe(v => {
    //     if(v != 'Request timed out'){
    //       this.turnout = v;
    //     }
    //   });
    // }
    // else{
    //   this.historicData.getTurnout(this.configs.historicData, election.electionType, election.electionDate, this.district, this.docket)
    //   .pipe(timeout(60000), catchError(error => of('Request timed out')))
    //   .pipe(take(1))
    //   .subscribe(v => {
    //     if(v != 'Request timed out'){
    //       this.turnout = v;
    //     }
    //   });
    // }

  // }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

}
